import React, { useEffect } from "react";
import { CheckCircle, XCircle } from "lucide-react";

const Toast = ({
  message,
  type = "success",
  onClose
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed top-5 right-5 z-50">

      <div
        className={`flex items-center gap-3 px-5 py-4 rounded-xl shadow-lg text-white min-w-[320px]
        ${
          type === "success"
            ? "bg-green-600"
            : "bg-red-600"
        }`}
      >

        {type === "success" ? (
          <CheckCircle size={22} />
        ) : (
          <XCircle size={22} />
        )}

        <span className="font-medium">
          {message}
        </span>

      </div>

    </div>
  );
};

export default Toast;